<script lang="ts">
  import { onMount } from "svelte";
  import { ensureSession, hasSession } from "../lib/session";

  interface Props {
    /** Вызывается, когда сессия есть (или только что получена). */
    onReady?: () => void;
  }

  let { onReady }: Props = $props();

  let phase = $state<"checking" | "idle" | "working" | "error" | "ready">("checking");
  let progress = $state<{ attempts: number; elapsedMs: number } | null>(null);
  let error = $state<string | null>(null);

  async function check(): Promise<void> {
    phase = "checking";
    if (await hasSession()) {
      phase = "ready";
      onReady?.();
    } else {
      phase = "idle";
    }
  }

  async function obtainSession() {
    error = null;
    phase = "working";
    progress = null;
    try {
      await ensureSession((p) => (progress = p));
      phase = "ready";
      onReady?.();
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
      phase = "error";
    }
  }

  onMount(() => {
    void check();
  });
</script>

{#if phase === "ready"}
  <button class="primary" onclick={() => onReady?.()}>start editing</button>
{:else if phase === "checking"}
  <span class="muted">checking session…</span>
{:else if phase === "working"}
  <div class="gate">
    <p>solving proof-of-work…</p>
    {#if progress}
      <p class="muted">
        {progress.attempts.toLocaleString()} attempts · {(progress.elapsedMs / 1000).toFixed(1)}s
      </p>
    {/if}
  </div>
{:else if phase === "error"}
  <div class="gate">
    <p class="error">{error}</p>
    <button onclick={obtainSession}>retry</button>
  </div>
{:else}
  <button class="primary" onclick={obtainSession}>create session</button>
{/if}

<style>
  .gate { text-align: center; max-width: 420px; }
  .gate p { margin: 8px 0; }
</style>